<template>
	<div class="wrapper">
		<div class="content-container">
			<div class="operate-container">
				  <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				    <el-form-item label="标题:" prop="title">
				      <el-input v-model="form.title"></el-input>
				    </el-form-item>
				    <el-form-item label="摘要:" prop="description">
				      <el-input type="textarea" v-model="form.description"></el-input>
				    </el-form-item>
				    <el-form-item label="正文:" prop="body">
						<WangEditor @modelValue="setValue"/>
				    </el-form-item>
					<el-form-item label="封面图片:" prop="descImages">
					  <el-upload class="uploadFile" :action="http" :on-success="handleChange" :headers="headers" :show-file-list="false" :limit="1">
					  	<el-image class="avatar" v-if="form.descImages" :src="form.descImages"></el-image>
					    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				    <el-form-item>
				      <el-button type="primary" @click="validate('1')">发布</el-button>
				      <!-- <el-button type="primary" @click="validate('0')">保存到草稿箱</el-button> -->
				      <el-button @click="cancle">取消</el-button>
				    </el-form-item>
				  </el-form>
			</div>
			
			<div class="sidebar">
				<div class="side-item">
					<div class="title">热门话题 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="topicList.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
					<div class="topic" v-for="(item,index) in topicList" :style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}">
						<span class="num" :class="{'top1':index==0,'top2':index==1,'top3':index==2}">{{index+1}}</span>
						<span class="topic-title" @click="todetail(item.id)">{{item.title}}</span>
					</div>	
					
				</div>
				
				<div class="side-item">
					<div class="title">公众号</div>
					<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
					<div class="tips">关注微信公众号，订阅每周资讯</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { topicCommit,gethotTopic } from '@/api/social/index'
import { getIsTrial, getToken } from '@/utils/auth'
import { apiBaseURL } from '@/utils/request'
import WangEditor from "@/components/wangEditor";
export default {
	components: {
	  WangEditor
	},
  data () {
    return {
       form:{
		"title": "",
		"description": "",
		"body": "",
		"descImages": "",
		"typeId": "2",
		"isRelease": "1"   // 1发布  0草稿
	   },
	   myConfig: {
	     serverUrl: '',
	     UEDITOR_HOME_URL: '/UEditor/'
	   },
	   ischange:false,
	   isToggle: true,
	   topicList:[],
	   http:'',
	   headers:{
		  token: ''
	   },
	   rules: {
	   	title:  [{ required:true, message: '请输入文章标题',trigger: 'blur'}],
		description: [{ required:true, message: '请输入文章摘要',trigger: 'blur'}],
	   	body: [{ required:true, message: '请输入文章内容',trigger: 'blur'}],
	   	descImages: [{ required:true, message: '请上传封面图片',trigger: 'blur'}],
	   }
    }
  },
  methods: {
	async onSubmit(){
		const res = await topicCommit(this.form)
		if (res.code === 0) {
			if(this.form.isRelease == '1'){
				this.$router.push({path:'/personal/homepage/topic'})
			}else{
				this.$router.push({path:'/personal/homepage/draft'})
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	validate(val){
		this.$refs.form.validate((valid) => {
		  if (valid) {
			// this.form.isRelease = val
			this.onSubmit()			
		  } else {
			return false;
		  }
		});
	},
	setValue(val){
		this.form.body = val=='<p><br></p>'?'':val
	},
	async hotTopic(){
		const res = await gethotTopic()
		if (res.code === 0) {
			this.topicList = res.data
		} else {
		  this.$message.error(res.msg)
		}
	},
	todetail(id){
		this.$router.push({path:'/social/detail/'+id})
	},
	cancle(){
		this.$confirm('确认要返回吗?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '保存到草稿箱',
		  type: 'warning'
		}).then(() => {
		  this.$router.go(-1)
		}).catch(() => {
		    this.form.isRelease = '0'
			this.onSubmit()
		});
	},
	toggleChange(){
		this.ischange = true
		this.isToggle = !this.isToggle
		setTimeout(() => {
		  this.ischange = false;
		}, 500); 
	},
	handleChange(response, file, fileList) {
  		this.form.descImages = response.data.src
    }
  },
  mounted () {
  	this.http = apiBaseURL+'/sys/oss/upload'  
  	this.headers.token = getToken()
	this.hotTopic()
  },

}
</script>

<style lang="scss" scoped>
.wrapper{
	background-color: #F9FAFD;
	width: 100vw;
	padding-top: 20px;
	margin: 80px auto 0;
	.publisher{
		color: #A1A7B0;
		font-size: 14px;
	}
	.headIcon{
		margin-right: 10px;
		.el-image{
			width: 26px;
			height: 26px;
			border-radius:50%;
		}
	}
}
.content-container{
	max-width: 1400px;
	width: 85vw;
	margin: auto;
}
.operate-container{
	display: inline-block;
	vertical-align: top;
	background-color: #fff;
	border-radius: 10px;
	padding: 30px;
	box-sizing: border-box;
	width: calc(100% - 300px);
	.edui-default .edui-editor{
		width: 100% !important;
	}
	.uploadFile /deep/.el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .uploadFile .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
}
/deep/.el-input.is-active .el-input__inner, 
/deep/.el-input__inner:focus,
/deep/.el-textarea__inner:focus{
	border-color: #C0C4CC;
}
.sidebar{
	display: inline-block;
	vertical-align: top;
	.active-image{
		.el-image{
			width: 270px;
			margin: 0 0 30px 30px;
		}
	}
	.side-item{
		width: 270px;
		box-sizing: border-box;
		padding: 24px;
		margin: 0 0 30px 30px;
		border-radius: 15px;
		box-shadow: 0 0 15px rgba(0,0,0, .05);
		background-color: #fff;
		.topic{
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			margin: 10px 0;
			.num{
				color: #BEBEC2;
				font-weight: 800;
				font-style: italic;
				margin-right: 10px;
				&.top1{
					color: #FE815F;
				}
				&.top2{
					color: #FEBC5F;
				}
				&.top3{
					color: #FEE35F;
				}
			}
			.topic-title{
				color: #525254;
				cursor: pointer;
			}
		}
		.title{
			font-size: 18px;
			font-weight: 800;
			color: #2B2B2B;
			margin-bottom: 15px;
		}
		.qrcode{
			margin: 20px auto;
			width: 80%;
			display: block;
		}
		.tips{
			font-size: 14px;
			color: #525254;
			text-align: center;
		}
		.btn{
			cursor: pointer;
			float: right;
			color: #AAAEB4;
			font-weight: 500;
			font-size: 14px;
			.el-icon-refresh-right{
				font-size: 20px;
				margin-right: 5px;
				vertical-align: bottom;
			}
		}
		.change-btn{
			.el-icon-refresh-right{
				transform:rotate(360deg);
				transition: all .5s;
			}
		}
		
	}
}
</style>